<template>
  <div class="page-container" v-loading="loading">
    <div class="yn-biz-header">
      <span class="yn-biz-title">周期任务管理</span>
      <div class="header-actions">
        <el-button type="primary" size="mini" @click="$router.push('/routine/new')">新增周期任务</el-button>
      </div>
    </div>

    <el-row :gutter="16">
      <el-col :span="5">
        <el-card shadow="never">
          <div slot="header">年度</div>
          <el-menu :default-active="String(year)" @select="onYear">
            <el-menu-item v-for="y in years" :key="y" :index="String(y)">{{ y }}</el-menu-item>
          </el-menu>
        </el-card>
      </el-col>
      <el-col :span="19">
        <el-tabs v-model="tab">
          <el-tab-pane label="周期项目" name="projects">
            <el-table :data="projects" border size="small">
              <el-table-column prop="xmbh" label="编号" width="130" />
              <el-table-column prop="xmmc" label="任务名称" min-width="180" />
              <el-table-column prop="wtdw_mc" label="企业" min-width="140" />
              <el-table-column prop="xmzt" label="状态" width="100" />
              <el-table-column prop="item_cnt" label="条目" width="70" align="center" />
              <el-table-column label="操作" width="160">
                <template slot-scope="{ row }">
                  <el-button type="text" size="small" @click="$router.push('/routine/' + encodeURIComponent(row.xmbh))">打开</el-button>
                  <el-button v-if="canPlanRow(row)" type="text" size="small" @click="$router.push('/routine/plan/' + encodeURIComponent(row.xmbh))">安排</el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-tab-pane>
          <el-tab-pane label="企业方案库" name="ents">
            <el-table :data="enterprises" border size="small">
              <el-table-column prop="ent_name" label="企业名称" min-width="200" />
              <el-table-column prop="site_cnt" label="点位条目" width="90" align="center" />
              <el-table-column label="操作" width="120">
                <template slot-scope="{ row }">
                  <el-button type="text" size="small" @click="startFromEnt(row)">发起周期任务</el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-tab-pane>
        </el-tabs>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import api from '@/utils/api'
import { canEditRoutinePlan } from '@/utils/user'

export default {
  data() {
    const y = new Date().getFullYear()
    return {
      loading: false,
      year: y,
      years: [y, y - 1, y - 2],
      tab: 'projects',
      projects: [],
      enterprises: []
    }
  },
  mounted() { this.load() },
  methods: {
    canPlanRow(row) {
      if (!row || !['audit_pass', 'plan_ready'].includes(row.xmzt)) return false
      return canEditRoutinePlan(row)
    },
    onYear(y) {
      this.year = parseInt(y, 10)
      this.load()
    },
    async load() {
      this.loading = true
      try {
        const res = await api.get('yn_routine_task_admin_list', { year: this.year })
        const d = res.data || {}
        this.projects = d.projects || []
        this.enterprises = d.enterprises || []
      } finally { this.loading = false }
    },
    startFromEnt(row) {
      this.$router.push({ path: '/routine/new', query: { ent_id: row.id, ent_name: row.ent_name, year: this.year } })
    }
  }
}
</script>

<style scoped>
.page-header { display: flex; justify-content: space-between; align-items: center; margin-bottom: 16px; }
</style>
